import {useAdminHostApprovalTaskImages} from 'src/features/admin-host-approval/services/useAdminHostApprovalTaskImages'
import {useTranslation} from 'react-i18next'
import {AdminHostApprovalRoomsAmenitiesImages} from 'src/features/admin-host-approval/components/admin-host-approval-rooms-amenities-images/AdminHostApprovalRoomsAmenitiesImages'
import {StyledAdminHostApprovalCompletedApprovedImagesHeader} from './style'

export const AdminHostApprovalCompletedApprovedImages = ({taskId}: {taskId: number}) => {
    const {t} = useTranslation()

    const {data: taskImages, isLoading: isLoadingTaskImages} = useAdminHostApprovalTaskImages(taskId, {
        enabled: false
    })

    return (
        <>
            <StyledAdminHostApprovalCompletedApprovedImagesHeader>
                <h3>{t('host_approval_task:approved_images')}</h3>
            </StyledAdminHostApprovalCompletedApprovedImagesHeader>
            <AdminHostApprovalRoomsAmenitiesImages
                taskId={taskId}
                isLoadingTaskImages={isLoadingTaskImages}
                emptyResultMessage={t('host_approval_task:no_images_approved')}
                taskImages={
                    taskImages
                        ? taskImages.filter(
                              taskImage => taskImage.amenity_id && taskImage.room_id && taskImage.is_host_approved
                          )
                        : []
                }
            />
        </>
    )
}
